export var SuccessCode;
(function (SuccessCode) {
    // TODO: should probably come up with different success codes
    SuccessCode[SuccessCode["GOOD"] = 0] = "GOOD";
    SuccessCode[SuccessCode["BAD"] = 1] = "BAD";
    SuccessCode[SuccessCode["UGLY"] = 2] = "UGLY";
})(SuccessCode || (SuccessCode = {}));
export var GridChangeType;
(function (GridChangeType) {
    GridChangeType[GridChangeType["CELL"] = 0] = "CELL";
    GridChangeType[GridChangeType["ROW"] = 1] = "ROW";
    GridChangeType[GridChangeType["COLUMN"] = 2] = "COLUMN";
    GridChangeType[GridChangeType["SUMMARY"] = 3] = "SUMMARY";
    GridChangeType[GridChangeType["CONDITIONAL_FORMAT_RULE"] = 4] = "CONDITIONAL_FORMAT_RULE";
    GridChangeType[GridChangeType["FILTER_RULE"] = 5] = "FILTER_RULE";
    GridChangeType[GridChangeType["ROW_ORDER"] = 6] = "ROW_ORDER";
    GridChangeType[GridChangeType["COLUMN_ORDER"] = 7] = "COLUMN_ORDER";
})(GridChangeType || (GridChangeType = {}));
// Formulas require some default ordering
var GridSubscribables;
(function (GridSubscribables) {
})(GridSubscribables || (GridSubscribables = {}));
// -- complete set subscriptions -- //
// column order - what is the criteria to define column order? Default, custom1, etc
// row order
// the
// -- change subscriptions -- //
// row changes
// cell changes
// column changes
// sheet summary changes
// conditional format rule changes
// filter rule changes
export function isAction(x) {
    return x.actionId !== undefined;
}
//# sourceMappingURL=Action.js.map